var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticStyle: {
            "font-size": "15px",
            color: "#1a1a1a",
            "font-weight": "600",
            "text-align": "center",
            padding: "15px 0"
          }
        },
        [_vm._v("调拨单信息")]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px",
            "word-break": "break-strict"
          }
        },
        [
          _c("tbody", { staticClass: "body" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.shopDeviceTransVoucher.innerNo || "无")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.shopDeviceTransVoucher.reservedNo || "无"
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.shopDeviceTransVoucher.totalQuantity || "无"
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.shopDeviceTransVoucher.totalNetWorth || "无"
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "54px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("创建机构")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.shopDeviceTransVoucher.creatorComName)
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "54px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("申请人")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.shopDeviceTransVoucher.applicantName)
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(5),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.shopDeviceTransVoucher.applicantContactTel
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "54px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("调出机构")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.shopDeviceTransVoucher.srcComFullName)
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(6),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.shopDeviceTransVoucher.srcBizUnitCode)
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(7),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.shopDeviceTransVoucher.srcCostCenterCode
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(8),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.shopDeviceTransVoucher.srcPrftCenterCode
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "54px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("调入机构")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.shopDeviceTransVoucher.dstComFullName)
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(9),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.shopDeviceTransVoucher.dstBizUnitCode)
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(10),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.shopDeviceTransVoucher.dstCostCenterCode
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(11),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.shopDeviceTransVoucher.dstPrftCenterCode
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "54px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("调拨日期")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.shopDeviceTransVoucher.createTime)
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "54px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("申请日期")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.shopDeviceTransVoucher.applyTime))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "54px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("生凭时间")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.shopDeviceTransVoucher.ledgerTime)
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(12),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.shopDeviceTransVoucher.applyDesc))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(13),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.shopDeviceTransVoucher.memo))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm._m(14)
            ])
          ])
        ]
      ),
      _vm._v(" "),
      !_vm.shopDeviceTransVoucher.suitFlag
        ? [
            _vm.deviceItemList != null && _vm.deviceItemList.length > 0
              ? [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "15px",
                        color: "#1a1a1a",
                        "font-weight": "600",
                        "text-align": "center",
                        padding: "15px 0"
                      }
                    },
                    [_vm._v("单品式管理")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.deviceItemList, function(deviceItem) {
                    return _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          border: "1px solid rgb(26, 26, 26)",
                          "margin-top": "10px",
                          padding: "5px 2px 10px 2px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px",
                              "word-break": "break-all",
                              "word-wrap": "break-word"
                            }
                          },
                          [
                            _vm._m(15, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(deviceItem.innerCode))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(16, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [_c("span", [_vm._v(_vm._s(deviceItem.title))])]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(17, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(deviceItem.fixedSpec || ""))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(18, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.assetNatureMap[deviceItem.assetNature]
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(19, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      deviceItem.fiscalAcctFlag ? "是" : "否"
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(20, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(deviceItem.quantity))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(21, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [_c("span", [_vm._v(_vm._s(deviceItem.theUnit))])]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(22, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                deviceItem.orgWorth != null
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(deviceItem.orgWorth.toFixed(2))
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(23, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                deviceItem.netWorth != null
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(deviceItem.netWorth.toFixed(2))
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(24, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                deviceItem.aggtDeprWorth != null
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          deviceItem.aggtDeprWorth.toFixed(2)
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(25, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                deviceItem.dstMerchantId !=
                                  deviceItem.retailerId &&
                                deviceItem.dstMerchantName != null
                                  ? _c("span", [
                                      _vm._v(_vm._s(deviceItem.dstMerchantName))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                deviceItem.dstMerchantId !=
                                  deviceItem.retailerId &&
                                deviceItem.dstMerchantName != null &&
                                deviceItem.dstBizUnitName != null
                                  ? _c("span", [_vm._v("/")])
                                  : _vm._e(),
                                _vm._v(" "),
                                deviceItem.dstBizUnitName != null
                                  ? _c("span", [
                                      _vm._v(_vm._s(deviceItem.dstBizUnitName))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                deviceItem.dstBizUnitName != null &&
                                deviceItem.dstComName != null &&
                                deviceItem.dstBizUnitName !=
                                  deviceItem.dstComName
                                  ? _c("span", [
                                      _vm._v(
                                        "/" + _vm._s(deviceItem.dstComName)
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(26, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(deviceItem.dstComNo || ""))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(27, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(deviceItem.dstCostCenterCode || "")
                                  )
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(28, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(deviceItem.dstInnerCode || ""))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(29, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(deviceItem.srcComName || ""))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(30, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(deviceItem.srcRealComCode || "")
                                  )
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(31, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(deviceItem.srcCostCenterCode || "")
                                  )
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(32, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                deviceItem.taxRate != null
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(deviceItem.taxRate.toFixed(2))
                                      )
                                    ])
                                  : _c("span", [_vm._v("0")])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(33, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(deviceItem.memo || ""))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(34, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(deviceItem.tmpNo || ""))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(35, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(deviceItem.reservedNo || ""))
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.durableItemList != null && _vm.durableItemList.length > 0
              ? [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "15px",
                        color: "#1a1a1a",
                        "font-weight": "600",
                        "text-align": "center",
                        padding: "15px 0"
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.shopDeviceTransVoucher.assetType != 2
                              ? "批量式管理"
                              : "耗材管理"
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.durableItemList, function(durableItem) {
                    return _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          border: "1px solid rgb(26, 26, 26)",
                          "margin-top": "10px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px",
                              "word-break": "break-all",
                              "word-wrap": "break-word"
                            }
                          },
                          [
                            _vm._m(36, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(durableItem.innerCode))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(37, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [_c("span", [_vm._v(_vm._s(durableItem.title))])]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(38, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(durableItem.fixedSpec || ""))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(39, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.assetNatureMap[
                                        durableItem.assetNature
                                      ]
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(40, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      durableItem.fiscalAcctFlag ? "是" : "否"
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(41, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(durableItem.quantity))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(42, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(durableItem.quantity2))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(43, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(durableItem.theUnit))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(44, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                durableItem.orgWorth != null
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(durableItem.orgWorth.toFixed(2))
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(45, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                durableItem.netWorth != null
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(durableItem.netWorth.toFixed(2))
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(46, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                durableItem.aggtDeprWorth != null
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          durableItem.aggtDeprWorth.toFixed(2)
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(47, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                durableItem.dstMerchantId !=
                                  durableItem.retailerId &&
                                durableItem.dstMerchantName != null
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(durableItem.dstMerchantName)
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                durableItem.dstMerchantId !=
                                  durableItem.retailerId &&
                                durableItem.dstMerchantName != null &&
                                durableItem.dstBizUnitName != null
                                  ? _c("span", [_vm._v("/")])
                                  : _vm._e(),
                                _vm._v(" "),
                                durableItem.dstBizUnitName != null
                                  ? _c("span", [
                                      _vm._v(_vm._s(durableItem.dstBizUnitName))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                durableItem.dstBizUnitName != null &&
                                durableItem.dstComName != null &&
                                durableItem.dstBizUnitName !=
                                  durableItem.dstComName
                                  ? _c("span", [
                                      _vm._v(
                                        "/" + _vm._s(durableItem.dstComName)
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(48, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(durableItem.dstComNo || ""))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(49, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(durableItem.dstCostCenterCode || "")
                                  )
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(50, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(durableItem.dstInnerCode || ""))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(51, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(durableItem.srcComName || ""))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(52, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(durableItem.srcRealComCode || "")
                                  )
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(53, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(durableItem.srcCostCenterCode || "")
                                  )
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(54, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                durableItem.taxRate != null
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(durableItem.taxRate.toFixed(2))
                                      )
                                    ])
                                  : _c("span", [_vm._v("0")])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(55, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(durableItem.memo || ""))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(56, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(durableItem.tmpNo || ""))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              width: "33.33%",
                              float: "left",
                              "margin-top": "5px",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._m(57, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "padding-left": "54px",
                                  "white-space": "normal",
                                  "word-break": "break-all",
                                  "word-wrap": "break-word",
                                  color: "#666666"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(durableItem.reservedNo || ""))
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  })
                ]
              : _vm._e()
          ]
        : [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "15px",
                  color: "#1a1a1a",
                  "font-weight": "600",
                  "text-align": "center",
                  padding: "15px 0"
                }
              },
              [_vm._v("套装明細")]
            ),
            _vm._v(" "),
            _vm._l(_vm.deviceItemList, function(deviceItem) {
              return _c(
                "div",
                {
                  staticStyle: {
                    overflow: "hidden",
                    border: "1px solid rgb(26, 26, 26)",
                    "margin-top": "10px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(58, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_vm._v(_vm._s(deviceItem.title))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(59, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_vm._v(_vm._s(deviceItem.tmpNo))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(60, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(deviceItem.suitMainFlag ? "是" : "否")
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(61, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_vm._v(_vm._s(deviceItem.suitNo))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(62, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_vm._v(_vm._s(deviceItem.catName))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(63, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.getDevcGroupNameByCatId(deviceItem.catId)
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(64, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(deviceItem.brandName))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(65, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(deviceItem.model || ""))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(66, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(deviceItem.fixedSpec || ""))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(67, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(deviceItem.srcComName))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(68, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(deviceItem.srcWarehouseName))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(69, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(deviceItem.dstComName))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(70, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(deviceItem.dstWarehouseName))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(71, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.allotAcntTypeMap[deviceItem.allotAcntType]
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            })
          ],
      _vm._v(" "),
      _vm.auditRecList != null &&
      _vm.auditRecList.length > 0 &&
      _vm.shopDeviceTransVoucher.outerAuditFlag
        ? [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "15px",
                  color: "#1a1a1a",
                  "font-weight": "600",
                  "text-align": "center",
                  padding: "15px 0"
                }
              },
              [_vm._v("审核记录")]
            ),
            _vm._v(" "),
            _vm._l(_vm.auditRecList, function(auditRecInfo) {
              return _c(
                "div",
                {
                  staticStyle: {
                    overflow: "hidden",
                    border: "1px solid rgb(26, 26, 26)",
                    "margin-top": "10px",
                    padding: "5px 2px 10px 2px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px",
                        "word-break": "break-all",
                        "word-wrap": "break-word"
                      }
                    },
                    [
                      _vm._m(72, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(auditRecInfo.nodeName))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(73, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(auditRecInfo.auditorName))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(74, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          auditRecInfo.nodeName != "提报"
                            ? _c("span", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(auditRecInfo.auditStatusStr || "")
                                  )
                                ])
                              ])
                            : _c("span", [_vm._v("已提报")])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(75, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(auditRecInfo.auditDesc || ""))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(76, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          auditRecInfo.finalNodeFlag
                            ? _c("span", [_vm._v("是")])
                            : _vm._e()
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(77, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(auditRecInfo.ts))])]
                      )
                    ]
                  )
                ]
              )
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.deviceRecList != null &&
      _vm.deviceRecList.length > 0 &&
      !_vm.shopDeviceTransVoucher.outerAuditFlag
        ? [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "15px",
                  color: "#1a1a1a",
                  "font-weight": "600",
                  "text-align": "center",
                  padding: "15px 0"
                }
              },
              [_vm._v("审核记录")]
            ),
            _vm._v(" "),
            _vm._l(_vm.deviceRecList, function(auditRecInfo) {
              return _c(
                "div",
                {
                  staticStyle: {
                    overflow: "hidden",
                    border: "1px solid rgb(26, 26, 26)",
                    "margin-top": "10px",
                    padding: "5px 2px 10px 2px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px",
                        "word-break": "break-all",
                        "word-wrap": "break-word"
                      }
                    },
                    [
                      _vm._m(78, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(auditRecInfo.retailerComName))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(79, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(auditRecInfo.ts))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(80, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(auditRecInfo.action || ""))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(81, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(auditRecInfo.retailerBizUnitName))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(82, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(auditRecInfo.actRole))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(83, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(auditRecInfo.actorName))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        width: "33.33%",
                        float: "left",
                        "margin-top": "5px",
                        "font-size": "12px"
                      }
                    },
                    [
                      _vm._m(84, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "54px",
                            "white-space": "normal",
                            "word-break": "break-all",
                            "word-wrap": "break-word",
                            color: "#666666"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(auditRecInfo.extraInfo))])]
                      )
                    ]
                  )
                ]
              )
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span", [_vm._v("基本信息")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("调拨单号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("记账凭证号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("调拨总数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("调拨净值总额")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("申请人电话")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("调出机构编码")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("调出成本中心")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("调出利润中心")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("调入机构编码")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("调入成本中心")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("调入利润中心")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("申请原因")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "54px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("备注说明")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px"
        }
      },
      [
        _c(
          "div",
          { staticClass: "info-item ", staticStyle: { overflow: "hidden" } },
          [
            _c(
              "div",
              {
                staticClass: "label",
                staticStyle: {
                  width: "54px",
                  float: "left",
                  color: "#1a1a1a",
                  "font-weight": "600",
                  "white-space": "normal",
                  "word-break": "break-all"
                }
              },
              [_vm._v(" ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "value",
                staticStyle: {
                  "padding-left": "54px",
                  "white-space": "normal",
                  "word-break": "break-all"
                }
              },
              [_c("span", [_vm._v(" ")])]
            )
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("资产编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("资产描述全称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("规格")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("资产属性")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("是否在账")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("单位")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("原值(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("净值(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("累计折旧(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调入机构")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调入机构编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调入成本中心")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调入资产编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调出部门")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调出公司编码")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调出成本中心")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("税率(%)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("备注")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("系统编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("记账凭证号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("资产编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("资产描述全称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("规格")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("资产属性")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("是否在账")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调拨数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("含报废数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("单位")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("原值(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("净值(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("累计折旧(元)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调入机构")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调入机构编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调入成本中心")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调入资产编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调出部门")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调出公司编码")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调出成本中心")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("税率(%)")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("备注")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("系统编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("记账凭证号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("设备名称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("系统编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("是否主资产")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("套装编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("设备分类")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("分类分组")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("设备品牌")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("设备型号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("设备规格")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调出部门")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调出仓库")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调入部门")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("调入仓库")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("核实类型")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("审批环节")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("审核人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("审核状态")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("审核描述")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("是否终审")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("审核时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("操作所属部门")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("操作时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("操作")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("操作业务单元")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("岗位")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("操作人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "54px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("操作描述")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a01bd5c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01bd5c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/transVoucher/ShopDeviceTransVoucherForPdf.vue
// module id = 2520
// module chunks = 0